module.exports = __webpack_public_path__ + "static/media/forum.f376f681.svg";